module.exports={
  "climate": {
    "color": "",
    "background": "",
    "label": "Climate Emergency",
    "date": "5/3/2022"
  },
  "homelessness": {
    "color": "",
    "background": "",
    "label": "Housing and Homelessness",
    "date": "5/3/2022"
  },
  "economics": {
    "color": "",
    "background": "",
    "label": "Economics",
    "date": "5/3/2022"
  },
  "policing": {
    "color": "",
    "background": "",
    "label": "Policing",
    "date": "10/12/2022"
  }
}